module.exports = __webpack_public_path__ + "resource/img/image013Dark.946be75e.png";